import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['nextVersionInput', 'incrementTypeInput', 'nextVersionHint']

  declare readonly nextVersionInputTarget: HTMLInputElement
  declare readonly nextVersionHintTarget: HTMLInputElement
  declare readonly incrementTypeInputTargets: HTMLInputElement[]

  declare versionNumber: string

  changeIncrementType (event: Event): void {
    const target = event.currentTarget as HTMLInputElement
    this.versionNumber = target.dataset.versionNumber ?? ''
    this.nextVersionInputTarget.value = this.versionNumber
  }

  toggleManual (event: Event): void {
    const target = event.currentTarget as HTMLInputElement

    this.nextVersionInputTarget.disabled = !target.checked

    if (target.checked) {
      if (this.versionNumber !== undefined) {
        this.nextVersionInputTarget.value = this.versionNumber
      }

      this.nextVersionHintTarget.classList.remove('hidden')
    } else {
      const incrementTypeInput = this.incrementTypeInputTargets.find((input) => input.checked)
      this.versionNumber = this.nextVersionInputTarget.value
      this.nextVersionHintTarget.classList.add('hidden')

      if (incrementTypeInput != null) {
        this.nextVersionInputTarget.value = incrementTypeInput.dataset.versionNumber ?? ''
      }
    }
  }
}
